import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmDialogConfig, ConfirmClick, ConfirmBanner } from '@shared/models/interfaces';
import { ToastService } from '@services/toast/toast.service';
import { InlineMessageComponent } from '../inline-message/inline-message.component';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatDialogModule, MatSelectModule, InlineMessageComponent, MatIcon],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationComponent {
  selectedReason: any = null;

  constructor(private readonly dialogRef: MatDialogRef<ConfirmationComponent, ConfirmClick>,
    private readonly toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public config: ConfirmDialogConfig){
      this.dialogRef.disableClose = !!config.disableClose;
      if (config.error) {
        this.toastService.show("Failed to load Cancellation reasons. Please try again.", 'error');
      }
  }

  get isConfirmDisabled(): boolean {
    return !!this.config.error || (!!this.config.reasonCodes?.length && !this.selectedReason);
  }

  get isReasonSelectDisabled(): boolean {
    return !!this.config.error || !this.config.reasonCodes?.length;
  }

  bannerType(): Exclude<ConfirmBanner['type'], 'confirm'> {
    const t = this.config.banner?.type;
    return (t === 'info' || t === 'success' || t === 'error' || t === 'warning') ? t : 'warning';
  }

  onConfirm(){
    if (this.config?.reasonCodes?.length) {
      this.dialogRef.close(this.selectedReason);
    } else {
      this.dialogRef.close(true);
    }
  }

  onCancel(){
    this.dialogRef.close(false);
  }

  onSecondary(){
    this.dialogRef.close('secondary');
  }

}
